//! =================================================================================
//* Función para abrir el menú lateral cuando el tamaño sea tablet o inferior
//! =================================================================================

export function apertura() {
    
    let menu    = document.getElementById('navPrincipal');
    let estiloMenu = window.getComputedStyle(menu);
    
    if (estiloMenu.width != "0px") {
        
        menu.style.width = '100vw!important';

    } else {
        
        menu.style.width = '0%'; 
        menu.style.overflow = 'hidden';

    }
    menu.classList.toggle('menu2');    
};   


//! =================================================================================
//* Función para marcar las opciones del menú dependiendo de la posición 
//* en la que se encuentre en pantalla
//! =================================================================================

export function updateActiveClass(menuLinks) {
    let found = false; 

    // Primero, quitar la clase 'nav_active' de todos los elementos
    menuLinks.forEach(link => link.parentElement.classList.remove('nav_active'));

    // Iterar a través de cada enlace del menú
    for (const link of menuLinks) {
        const sectionId = link.getAttribute('href').substring(1); // Eliminar el '#' del href
        const section = document.getElementById(sectionId);

        if (section) {
            const rect = section.getBoundingClientRect();

            // Comprobar si la sección está en la ventana de visualización
            if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {

                link.parentElement.classList.add('nav_active');
                found = true;

            } else {

                link.parentElement.classList.remove('nav_active');

            }
        }
    }
}

//! =================================================================================
//* Función para llenar el slider de los banners de publicidad
//! =================================================================================

export function llena_bannerspub(div_pub) {
    let pathServer = '';
    let folderPub = '';
    let divIndicadores = document.getElementById('div_indicadores');

    div_pub.innerHTML = '';
    divIndicadores.innerHTML = '';

    fetch('https://www.apiweb.servidorbdk.com/tbconfigs?select=path_server,folder_banners')
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al conectarse a la API para obtener los datos del servidor.');
            }
            return response.json();
        })
        .then(data => {
            if (data.status === 200 && data.results.length > 0) {
                const dtServer = data.results[0];
                pathServer = dtServer.path_server.trim();
                folderPub = dtServer.folder_banners.trim();

                // Ahora sí hacemos el segundo fetch dentro del .then
                return fetch('https://www.apiweb.servidorbdk.com/tbbannerspub?linkTo=activo&equalTo=1&select=idbanner,descripcion,banner,nomfile,linkweb');
            } else {
                throw new Error('No se encontraron datos del servidor FTP.');
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al consultar la API de los banners publicitarios.');
            }
            return response.json();
        })
        .then(data => {
            const anuncios = data.results;
            shuffleArray(anuncios);
            let i = 0;

            anuncios.forEach(anuncio => {
                let button = document.createElement("button");
                button.setAttribute("type", "button");
                button.setAttribute("data-bs-target", "#crs_pub");
                button.setAttribute("data-bs-slide-to", i.toString());

                const link_anuncio = document.createElement('div'); 
                link_anuncio.classList.add('carousel-item');
                if (i === 0) {
                    button.classList.add("active");
                    link_anuncio.classList.add('active');
                }
                i++;

                const srcImage = `${pathServer}/${folderPub}/${anuncio.nomfile}`;

                let linkContent = `
                    <picture>
                        <img loading="lazy" src="${srcImage}" alt="Banner publicitario" class="d-block fto-img-pub" style="width:100%">
                    </picture>
                `;

                if (anuncio.linkweb && anuncio.linkweb.trim() !== '') {
                    const isExternal = anuncio.linkweb.startsWith('http');
                    const targetAttr = isExternal ? 'target="_blank"' : '';
                    linkContent = `
                        <a href="${anuncio.linkweb}" ${targetAttr}>
                            ${linkContent}
                        </a>
                    `;
                }

                link_anuncio.innerHTML = linkContent;

                divIndicadores.appendChild(button);
                div_pub.appendChild(link_anuncio);
            });
        })
        .catch(error => {
            console.error('Error en el proceso de carga de banners:', error);
        });
}

//* Función para ordenar aleatoriamente un arreglo

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // random index from 0 to i
        [array[i], array[j]] = [array[j], array[i]]; // swap elements
    }
}


//! =================================================================================
//* Función para reproducir vídeos de Youtube directamente en la página
//! =================================================================================

export function reproduce_video_youtube(event) {

    event.preventDefault(); // Previene que el enlace se abra directamente

    const obj = event.currentTarget; // El elemento que recibió el clic
    const container = obj.closest('.youtube-container'); // Encuentra el contenedor principal

    const iframeElement = container.querySelector(".youtube-video iframe"); // Encuentra el iframe dentro del contenedor
    iframeElement.src = ""; // Limpia el src para asegurar que el video se detiene si estaba jugando

    const portadaElement = container.querySelector('.youtube-portada'); // Encuentra el contenedor de la portada
    if (portadaElement) {
        portadaElement.remove(); // Elimina la portada si existe
    }

    // Configura la nueva URL del iframe con autoplay
    iframeElement.setAttribute("src", "https://www.youtube.com/embed/"+obj.dataset.embed+"?autoplay=1" );  // Autoplay y mute

}

//! =================================================================================
//* Función para reproducir vídeos de Youtube de los módulos del sistema
//! =================================================================================

export function reproduce_video_modulo(event) {

    event.preventDefault(); // Previene que el enlace se abra directamente

    console.log('Si llega a la función reproduce_video_modulo');
    

    // const obj = event.currentTarget; // El elemento que recibió el clic

    const obj = event.target.closest('.play-modulo');

    const container = obj.closest('.modulo-container'); // Encuentra el contenedor principal

    const iframeElement = container.querySelector(".modulo-video iframe"); // Encuentra el iframe dentro del contenedor
    iframeElement.src = ""; // Limpia el src para asegurar que el video se detiene si estaba jugando

    const portadaElement = container.querySelector('.modulo-portada'); // Encuentra el contenedor de la portada
    if (portadaElement) {
        portadaElement.remove(); // Elimina la portada si existe
    }

    // Configura la nueva URL del iframe con autoplay
    // iframeElement.setAttribute("display", "block" );
    iframeElement.setAttribute("src", "https://www.youtube.com/embed/"+obj.dataset.embed+"?autoplay=1" );  // Autoplay y mute

}


//! =================================================================================
//* Functión para reproducir un vídeo de las reseñas
//! =================================================================================

export function reproduce_testimonio( obj ) {

    const videoId = $(obj).data('embed'); // Obtiene el ID del video directamente del atributo data-embed
    const iframeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

    // Verifica si los elementos existen antes de intentar usarlos
    if ($('#ventanaVideo').length && $('#iframeVideo').length) {
        $('#iframeVideo').attr('src', iframeUrl);
        $('#ventanaVideo').modal('show');
    } else {
        console.error('Los elementos necesarios no están en esta página.');
    }

}

//! =================================================================================
//* Functión para activar la reproducción de las transmisiones en vivo.
//! =================================================================================

export function activa_Transmision() { 

    fetch('https://www.apiweb.servidorbdk.com/tbtransmision?select=activa,linksrc')
    .then(response => response.json())
    .then(data => {
        const info = data.results[0]; // Asumiendo que siempre hay al menos un resultado
        const enVivo = document.getElementById('widgetEnVivo');
        const videoIframe = document.querySelector('.video_envivo iframe');
        const repeticion = document.getElementById('repeticion_trans');        

        videoIframe.src = info.linksrc; // Actualiza el enlace del iframe        

        if (info.activa === "1") {
            enVivo.style.display = 'block';
            repeticion.style.display = 'none';
        } else {
            enVivo.style.display = 'none';
            repeticion.style.display = 'block';
        }
    })
    .catch(error => {
        console.error('Error al cargar la información de la transmisión:', error);
        document.getElementById('enVivo').style.display = 'none'; // Ocultar en caso de error
    });
    
}

//! =================================================================================
//* Función para enviar los eventos a META ADS mediante la API de Conversiones
//! =================================================================================

export async function registrarEventoEnLaApiMetaAds(eventName, email, phone, name) {

    const url = "https://www.bdkrest.com/api_conversiones/send_event.php";

    let fbc = getCookieValue('_fbc') || null; 
    let fbp = getCookieValue('_fbp') || null;

    // Generar fbp si no existe
    let nuevoFbp = fbp;
    if (!fbp) {
        nuevoFbp = `fb.1.${Date.now()}.${Math.floor(Math.random() * 1000000000)}`;
        document.cookie = `_fbp=${nuevoFbp}; path=/; max-age=2592000`; // 30 días
        fbp = nuevoFbp;
    }

    // Generar fbc si no existe y hay fbclid en la URL
    let nuevoFbc = fbc;
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (!fbc && fbclid) {
        nuevoFbc = `fb.1.${Date.now()}.${fbclid}`;
        document.cookie = `_fbc=${nuevoFbc}; path=/; max-age=2592000`; // 30 días
        fbc = nuevoFbc;
    }

    // Intentamos obtener el eventID del Píxel (si Meta lo asignó)
    let eventID = window.fbq && window.fbq.getEventId ? window.fbq.getEventId() : "event_" + Date.now();    

    console.log(`Registrando evento: ${eventName}`, {
        name,
        email,
        phone,
        fbc,
        fbp
    });
    
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'Allow-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
            event_name: eventName,
            event_id: eventID, // Ahora enviamos el mismo event_id del Píxel si existe            
            ...(name && { name: name }), // Agrega name si está disponible            
            ...(email && { email: email }), // Agrega email si está disponible
            ...(phone && { phone: phone }), // Agrega phone si está disponible
            ...(fbc && { fbc: fbc }), // Agrega fbc si está disponible
            ...(fbp && { fbp: fbp }) // Agrega fbp si está disponible

        }),        
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
    })
    .then(data => {
        console.log(`Evento "${eventName}" enviado con éxito:`, data);
    })
    .catch(error => {
        console.error(`Error al enviar el evento "${eventName}":`, error.message);
    });
}

//! =================================================================================
//* Función para capturar el valor de la cookie, para que la API de conversiones
//* pueda detectar el click
//! =================================================================================

function getCookieValue(cookieName) {

    const cookies = document.cookie.split('; ');

    for (let cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name === cookieName) {
            return value;
        }
    }
    return null;

}
